// componentes
import ServicioItem from '../componentes/ServicioItem'

// Data
import data_servicios from '../Data/data_servicios'

// Interface del usuario (GUI)
import {CardImage, CardBody, CardTitle, CardText, Card, Button } from 'mdbreact' 

// React
import React, {Component}  from 'react';

class Servicios extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: data_servicios()
    };
  } //fin constructor

  data_servicios = this.data_servicios
  render () {
    const { data } = this.state;
    return (
      <div>
        { data.map( (item) =>  <ServicioItem { ...item }  /> ) }
      </div>
    )
  } //fin render
} //fin class

export default  Servicios


// WEBPACK FOOTER //
// ./src/paginas/Servicios.js